import { apiPost } from '../../api'

export const remove_learners = payload => {
  return apiPost({
    endpoint: `groups/remove_learners`,
    data: payload
  })
}
